<!-- footer start-->
<div class="container-fluid">
  <div class="row">
    <div class="col-md-6 footer-copyright">
      <p class="mb-0">Copyright 2018 © Legal Assure All rights reserved.</p>
    </div>

    <div class="col-md-6">
    </div>
  </div>
</div>
